import { $, html, on, View } from 'rune-ts';
import { makeHomeScreenNavigate } from '../../../../shared/app/navigate';
import { dataStr } from '../../../../shared/util/dataStr';
import klass from './LandingHeader.module.scss';
import { staticTypo, typo } from '../../../../shared/typography/typo';
import { DropdownDownIcon, DropdownUpIcon, MarppleShopLogo, MarppleShopTextLogo } from '../../atoms/Icon';
import { pipe, reject, toArray } from '@fxts/core';
import NewHeadroom from 'headroom.js';

export const RANDING_HEADER_MENUS = [
  {
    name: 'Creator',
    url: '/@/hello_creator',
  },
  {
    name: 'Plus',
    url: '/@/plus',
  },
  {
    name: 'Pop-up Store',
    url: '/@/popupstore/offline',
  },
  {
    name: 'Brand Commerce',
    url: '/@/brand_commerce',
  },
  {
    name: 'MarppleShop X Youtube',
    url: '/@/youtube',
  },
] as const;

type LandingMenus = (typeof RANDING_HEADER_MENUS)[number];

export type LandingMenu = {
  readonly [K in keyof LandingMenus]: LandingMenus[K];
};

export interface LandingHeaderData {
  menus?: typeof RANDING_HEADER_MENUS;
  current_menu: LandingMenu;
  is_mobile: boolean;
  bg_white?: boolean;
}

interface LandingHeaderOption {
  klass?: string;
}

export class LandingHeader extends View<LandingHeaderData> {
  state: LandingHeaderOption & {
    // FIXME
    is_open: boolean;
  };

  constructor(data: LandingHeaderData, option: LandingHeaderOption = {}) {
    super(data);

    this.data.menus = data.menus || RANDING_HEADER_MENUS;

    this.state = {
      klass: option.klass,
      is_open: false,
    };
  }

  override template() {
    const { menus, current_menu, is_mobile, bg_white } = this.data;
    const { is_open } = this.state;
    const _menus = pipe(
      menus || RANDING_HEADER_MENUS,
      reject((menu) => menu.name == current_menu.name),
      toArray,
    );

    return html`
      <div
        class="${this.state.klass} ${klass.randing_header} ${bg_white ? klass.bg_white : ''} ${typo(
          '14_medium',
        )}"
        data-open="${is_open}"
      >
        <div class="${klass.logo}">
          <a href="/" data-post-message="${dataStr(makeHomeScreenNavigate())}">
            <span class="${klass.mp_logo}">${is_mobile ? MarppleShopLogo : MarppleShopTextLogo}</span>
          </a>
        </div>
        <div class="${klass.current_menu}">
          <span
            class="${klass.current_menu_title} ${is_mobile
              ? staticTypo('bebas_24_bold')
              : staticTypo('bebas_32_bold')}"
            >${current_menu.name}</span
          >
          <span class="${klass.current_menu_arrow}">${is_open ? DropdownUpIcon : DropdownDownIcon}</span>
        </div>

        <div class="${klass.menus}">
          <div class="${klass.menus_wrap}">
            ${_menus.map(
              (menu) => html`
                <div class="${klass.menu}">
                  <a
                    href="${menu.url}"
                    class="${is_mobile ? staticTypo('bebas_24_bold') : staticTypo('bebas_32_bold')}"
                    >${menu.name}</a
                  >
                </div>
              `,
            )}
          </div>
        </div>
      </div>
    `;
  }

  @on('click', `.${klass.current_menu}`)
  clickMenu() {
    this.state.is_open = !this.state.is_open;
    this.redraw();
  }

  override redraw(): this {
    this.element().dataset.open = `${this.state.is_open}`;

    const arrow_icon = () => {
      if (this.state.is_open) {
        return DropdownUpIcon.make(this);
      } else {
        return DropdownDownIcon.make(this);
      }
    };
    $(this.element()).find(`.${klass.current_menu_arrow}`)?.setInnerHtml(arrow_icon());

    return this;
  }

  protected override onRender() {
    const headroom_el$ = this.element();
    const headroom = new NewHeadroom(headroom_el$, {
      onPin: () => {
        if (this.state.is_open) {
          this.state.is_open = false;
          this.redraw();
        }
      },
      onUnpin: () => {
        if (this.state.is_open) {
          this.state.is_open = false;
          this.redraw();
        }
      },
    });
    headroom.init();
  }
}
